/**
 * Sentry init — error tracking + performance.
 *
 * Si attiva SOLO se la env var REACT_APP_SENTRY_DSN è settata.
 * In assenza, è un no-op silente (no console spam, no errori).
 *
 * Setup:
 *   1. Vai su https://sentry.io → crea progetto "React"
 *   2. Copia il DSN (formato https://abc@o123.ingest.sentry.io/4567)
 *   3. Aggiungi a /app/frontend/.env (preview) e Vercel/Emergent (produzione):
 *        REACT_APP_SENTRY_DSN=https://...
 *   4. Restart frontend
 *
 * Privacy: la maskAllText e maskAllInputs sono disattivate perché Pronto
 * non gestisce dati sensibili a parte email (già scrubbata da Sentry default).
 */
import * as Sentry from "@sentry/react";

const DSN = process.env.REACT_APP_SENTRY_DSN;
const ENV = process.env.REACT_APP_ENV || (process.env.NODE_ENV === "production" ? "production" : "preview");

if (DSN) {
  Sentry.init({
    dsn: DSN,
    environment: ENV,
    // Performance monitoring — 10% delle transazioni in prod, 100% in preview
    tracesSampleRate: ENV === "production" ? 0.1 : 1.0,
    // Session replay — solo errori per non saturare la quota free
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false }),
    ],
    // Filtra errori "rumore" che non aiutano a debuggare niente
    ignoreErrors: [
      "ResizeObserver loop limit exceeded",
      "ResizeObserver loop completed with undelivered notifications",
      "Non-Error promise rejection captured",
      "Network Error",
      // Safari / Firefox quirks
      "Load failed",
      "AbortError",
    ],
    // Tagga ogni evento con info utili per filtraggio
    beforeSend(event) {
      // Skip events dalla preview environment se è prod (e viceversa)
      // — utile per evitare cross-talk se DSN condiviso
      return event;
    },
  });
  // Log discreto solo in preview
  if (ENV !== "production") {
    // eslint-disable-next-line no-console
    console.info("[Sentry] active · env =", ENV);
  }
}

export { Sentry };
